<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="onCancel()"><ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Comments</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <div class="ion-padding ion-text-center" *ngIf="comments.length === 0">
      <ion-text color="darkmimbo">
        This post does not have any comments.</ion-text>
    </div>
    <div *ngIf="comments.length > 0">
      <ion-list>
        <ion-item *ngFor="let comment of comments" color="lightmimbo">
          <ion-text><b class="username" (click)="openUserOptions(comment.userid, comment.username)"> {{ "@" +
              comment.username }}
            </b><br />{{
            comment.comment
            }}</ion-text>
          <ion-button class="options" fill="clear" (click)="presentActionSheet(comment)">
            <ion-icon name="ellipsis-vertical-outline" slot="icon-only"></ion-icon></ion-button> </ion-item>
      </ion-list>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar color="lightmimbo">
    <ion-input placeholder="Type your comment here..." class="ion-padding" color="primary" [(ngModel)]="NewComment"
      maxlength="250" color="lightmimbo"></ion-input>
    <ion-buttons slot="primary">
      <ion-button fill="clear" class="ion-no-padding" (click)="addComment()" color="primary"><ion-icon name="send"
          slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>